import { jsx as _jsx } from "react/jsx-runtime";
import { ImageCheckbox } from '@as/cotopaxi';
import { MULTISELECT_FILTER } from '@as-react/common-types';
import { capitalize } from '@as-react/common-utils';
import { Box, Grid } from '@yonderland/andes-react';
const FILTER_ITEM_COLOR_DIMENSION = 32;
export const FilterItemContentColorFilter = ({ filter, onFilterItemChange, desktop, isCollapsedByDefault, }) => {
    const toggleFilterValue = (e) => {
        const filteredItem = filter.values.find((value) => value.filterKey === e.target.value);
        if (filteredItem) {
            onFilterItemChange({
                filterOn: filter.filterOn,
                filterOnName: filter.name,
                filteredItems: [
                    {
                        filterKeyName: filteredItem.name,
                        filterKey: filteredItem.filterKey,
                        filterOn: filter.filterOn,
                        filterOnName: filter.name,
                        filterType: MULTISELECT_FILTER,
                    },
                ],
                filterType: MULTISELECT_FILTER,
                filterDisplayHint: filter.displayHint,
                filterContentType: filter.filterContentType,
            });
        }
    };
    return (_jsx(Grid, { columns: 12, gap: "0", children: filter.values.map((value, index) => (_jsx(Grid.Cell, { span: 6, children: _jsx(Box, { paddingBlockEnd: "2", paddingBlockStart: index > 1 ? '2' : '0', children: _jsx(ImageCheckbox, { id: desktop ? `color_${filter.name}_${value.filterKey}-desktop` : `color_${filter.name}_${value.filterKey}`, name: `color_${filter.name}_${value.filterKey}`, imageUrl: `/content/dam/general/lister/color_filters/${value.filterKey}.svg`, value: value.filterKey, label: capitalize(value.name), itemCount: value.itemCount, checked: value.active, onChange: toggleFilterValue, imageLazyLoad: isCollapsedByDefault === false, imageHeight: FILTER_ITEM_COLOR_DIMENSION, imageWidth: FILTER_ITEM_COLOR_DIMENSION }) }) }, `color_${filter.name}_${value.filterKey}`))) }));
};
